export async function handleResponse(response) {
  
  if (response.ok) return response.json();
  if (response.status === 400) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }
  throw new Error("Network response was not ok.");
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  
  // eslint-disable-next-line no-console
  console.error("API call failed. " + error);
  throw error;
}


export function fetchTestData2(dataFilePath) {
  return import(
    /* webpackInclude: /\.json$/ */
    /* webpackChunkName: "[request]" */
    /* webpackMode: "lazy" */
    `./data/${dataFilePath}`
  ).then((res) => res.default);
}


export async function fetchTestData(dataFilePath) {
  const response = await fetch("/api/data/" + dataFilePath);
  return response.json();
}

export async function fetchToken(tech) {
  var requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
  };
  return fetch("/api/gettoken/", requestOptions).then(handleResponse).
    catch(handleError).then((data) => {
      return  "http://agilesparksexams.com/"+tech +"/" + data.token;;
    });
}

export async function verifyToken(token) {
  var requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
  };
  return fetch("/api/verify/"+ token, requestOptions).then(handleResponse).
    catch(handleError).then((data) => {
      if(data.verified === "true")
        return true;
      else
        return false;
    });
}

export async function fetchUserTestData(test_id) {
  const response = await fetch("/api/tests/" + test_id);
  return response.json();
  

}
export async function submitUserInfo(test_id, name,email,exp,id) {
  var requestOptions = {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      test_id: test_id,
      id,id,
      action: "start",
      payload: {
        name: name,
        email: email,
        yop:exp,
      },
    }),
  }
  return fetch("/api/start", requestOptions).then(handleResponse).
    catch(handleError).then((data) => {
      return data;
    });
}

export function submitTest({docId, userData, answers, tsStart, tsEnd}) {
  const finalData = {
    name: userData.name,
    exp: userData.exp,
    tsStart: new Date(tsStart).toISOString(),
    tsEnd: new Date(tsEnd).toISOString(),
  };
  /*answers.forEach((ans, idx) => {
    finalData["a" + idx] = ans;
  });*/

  console.log("Send to server", answers);
  return fetch("/api", {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      docId: docId,
      action: "finish",
      payload: answers,
    }),
  });
  
}

export function loginUser(data) {

  var requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(data)
  };
  console.log("this is the data: ",data);

  return fetch("/auth", requestOptions).then(handleResponse).
    catch(handleError).then((data) => {
      return data;
    });

}
